import { CookieSettings } from "@/Contexts/CookieManagerContext";

export const GPC_OPT_OUT_SETTINGS: CookieSettings = {
    analytics: false,
    advertising: false,
};

export function isGlobalPrivacyControlOn(): boolean {
    return (
        "globalPrivacyControl" in navigator &&
        navigator.globalPrivacyControl === true
    );
}
